import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { selectedTagsI } from '@/pages/ProfessionPage/SearchBox'

interface setOverviewTagsListI {
  keyword: string
  tagsList: selectedTagsI
}

const initialState: setOverviewTagsListI = {
  keyword: '',
  tagsList: {
    主题: [],
    朝代: [],
    类型: [],
    材质: [],
    形制: [],
    画派: []
  }
}

export const setOverviewTagsListSlice = createSlice({
  name: 'setOverviewTagsList',
  initialState,
  reducers: {
    setKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload
    },
    setTagsList: (state, action: PayloadAction<selectedTagsI>) => {
      state.tagsList = action.payload
    }
  }
})
export const { setKeyword, setTagsList } = setOverviewTagsListSlice.actions
export default setOverviewTagsListSlice.reducer
